import { BaseNetworkActionValidator } from '../base.network.action.validator';
import { ProtectedEntity } from '@nirvana/shared/dtos/types/protected-entities/common';
import { ProtectedEntitiesHelper } from '../../../helpers/protectedEntities/protected.entities.helper';

export class TreeRenameActionValidator extends BaseNetworkActionValidator {
  protected canRunForUnmanagedCompanies = false;
  protected requiresTasksEnabled = false;
  protected canRunOnMultipleCompanies = false;

  protected _canPerformAction(record: ProtectedEntity): boolean {
    const isServiceTarget = this.isRecordInTargets(record);
    return ProtectedEntitiesHelper.isEditableFolder(record) && !isServiceTarget;
  }
}
